<script setup lang="ts">
  import {
    modalSkeletonContainerClass,
    modalContentClass,
  } from './ModalSkeleton.css';
  import { ModalSkeletonSize } from './ModalSkeleton.types';

  interface Props {
    size?: ModalSkeletonSize;
  }

  const props = withDefaults(defineProps<Props>(), {
    size: ModalSkeletonSize.FULL,
  });
</script>

<template>
  <div :class="modalSkeletonContainerClass[props.size]">
    <slot name="title" />
    <slot name="content">
      <div :class="modalContentClass"><slot /></div>
    </slot>
    <slot name="actions" />
  </div>
</template>
